import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateVideoPlayerVolumeControlActive } from 'actions/videoPlayer';

import VolumeButton from './volume-button';
import VolumeLevel from './volume-level';

import Slider from 'components/slider';

import './styles.less';

const propTypes = { onVolumeChange: PropTypes.func };

const VOLUME_INACTIVE_TIMEOUT = 100;

class VolumeControl extends Component {
  state = {
    movingSlider: false,
    mouseEntered: false,
  };

  render() {
    const { muted, onButtonClick, seeking, volume } = this.props;
    const { mouseEntered, movingSlider } = this.state;

    const volumeAsPercentage = (volume * 100).toFixed(2);
    const inHoverState = mouseEntered && !seeking;

    return (
      <div
        className={classNames('video-player-volume-control', {
          hovered: inHoverState || movingSlider,
        })}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <VolumeButton
          muted={muted}
          onButtonClick={onButtonClick}
          volume={volume}
        />
        <Slider
          ref={slider => (this.slider = slider)}
          getPercent={this.getPercent}
          label={'Volume Level'}
          onMouseMove={this.onMouseSliderMove}
          onMouseUp={this.onMouseSliderUp}
          valueNow={volumeAsPercentage}
        >
          <VolumeLevel />
        </Slider>
      </div>
    );
  }

  onMouseSliderMove = e => {
    this.setState({ movingSlider: true });

    if (!this.props.onVolumeChange) {
      return;
    }

    const newVolume = this.slider.calculateDistance(e);

    this.props.onVolumeChange(newVolume);
  };

  onMouseSliderUp = () => {
    this.setState({ movingSlider: false }, () => {
      const { mouseEntered } = this.state;

      if (!mouseEntered) {
        this.deactivate();
      }
    });
  };

  onMouseEnter = () => {
    this.setState({ mouseEntered: true });

    if (!this.props.seeking) {
      this.activate();
    }
  };

  onMouseLeave = () => {
    this.setState({ mouseEntered: false }, () => {
      const { movingSlider } = this.state;

      if (!movingSlider) {
        this.deactivate();
      }
    });
  };

  activate = () => {
    window.clearTimeout(this.deactivateAnimationTimeout);
    this.props.updateVideoPlayerVolumeControlActive(true);
  };

  deactivate = () => {
    this.deactivateAnimationTimeout = window.setTimeout(() => {
      this.props.updateVideoPlayerVolumeControlActive(false);
    }, VOLUME_INACTIVE_TIMEOUT);
  };

  getPercent = () => {
    const { muted, volume } = this.props;

    if (muted) {
      return 0;
    }

    return volume;
  };
}

VolumeControl.propTypes = propTypes;

const mapDispatchToProps = dispatch => {
  return {
    updateVideoPlayerVolumeControlActive: active =>
      dispatch(updateVideoPlayerVolumeControlActive(active)),
  };
};

export default connect(null, mapDispatchToProps)(VolumeControl);
